var map = {
	"./ar.json": 79675,
	"./de.json": 532,
	"./en-US.json": 65458,
	"./es.json": 83458,
	"./fr.json": 71822,
	"./hi.json": 78274,
	"./it.json": 65744,
	"./pt.json": 86709,
	"./ru.json": 88809,
	"./zh-CN.json": 87258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85189;